import qs from 'qs';
import axios from './axios.config';
import def from './api.def';

let api = {};

for (let fn in def) {
  let [url, method, dataType] = def[fn];

  api[fn] = (data, config = {}) => {
    let cfg = {
      url,
      method,
      headers: config.headers || {},
      ...config,
    };
  
    if (dataType === 'qs') {
      cfg.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      data = qs.stringify(data);
    } else if (dataType === 'form') {
      cfg.headers['Content-Type'] = 'multipart/form-data';
      let form = new FormData();
      
      for (let k in data) form.append(k, data[k]);

      data = form;
    }  
      
    // `data` 是作为请求主体被发送的数据
    // 只适用于这些请求方法 `PUT`, `POST`, 和 `PATCH`
    if (method === 'put' || method === 'post' || method === 'patch') {
      cfg.data = data;
    } else {
      cfg.params = data;
    }

    return axios.request(cfg);
  };
}

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js